var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNumberIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 51.187,
    height: 87.622,
    viewBox: "0 0 51.187 87.622",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_32402",
    x: 0,
    y: 0,
    width: 51.187,
    height: 87.622,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    filter: "url(#Path_32402)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32402-2",
    "data-name": "Path 32402",
    d: "M13.085,6.51H1.312V-49.411L-14.825-37.74q-5.277-2.03-5.277-6.191,0-3.755,4.77-7l12.179-8.424q5.379-3.755,9.743-3.755a13.6,13.6,0,0,1,3.654.507,7.945,7.945,0,0,1,2.842,1.319Z",
    transform: "translate(29.1 69.11)",
    fill: "#fcbf49"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumberIcon1);
export default __webpack_public_path__ + "static/media/number-icon1.019281b8ae6fee4355985f29f61b9bd6.svg";
export { ForwardRef as ReactComponent };